<template>
  <div>
    <div>
      <div class="w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px">
        <router-link :to="{ name: 'Payment' }">
          <svg-filler @click="clear()" class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
        </router-link>
        <span>
          ชำระเงินด้วยเงินสด
        </span>
      </div>
       <div class="w-100pct h-60calc">
        <div class="pd-t-13px">
          <img src="/static/img/icons/apple-touch-icon-180x180.png" class="w-78px">
        </div>
        <div class="mg-t-23px f-s-16px f-w-bold">
          <span>ยอดที่ต้องชำระ ฿ {{ netPrice | showFullPriceFormat() }}</span>
        </div>
        <div class="mg-t-16px f-s-14px">
          ใส่จำนวนเงินที่ได้รับ
        </div>
        <div class="mg-t-8px f-s-14px w-300px mg-auto">
          <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="addReceive(1000)">
            1,000
          </div>
          <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="addReceive(2000)">
            2,000
          </div>
          <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="addReceive(3000)">
            3,000
          </div>
          <!-- <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="receive += 4000">
            4,000
          </div> -->
          <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="addReceive(5000)">
            5,000
          </div>
           <div class="price-btn pd-8px cs-pointer mg-l-7px f-left" @click="clear()">
            Clear
          </div>
        </div>
        <br>
        <br>
        <div class="pd-t-8px f-s-14px w-190px mg-auto">
          <input class="price-inp pd-6px f-left" type="number" placeholder="0,000" min="0" v-model="receive" @input="calculatedChange({receive, netPrice})">
          <!-- <div class="calculate-price-btn f-left pd-8px cl-white cs-pointer" @click="checkCalculatedChange({receive, netPrice})">
            OK
          </div> -->
        </div>
        <br>
        <br>
        <div class="mg-t-10px f-s-16px f-w-bold">
          จำนวนเงินทอน <br>
          ฿ {{ change | showFullPriceFormat() }}
        </div>
        <div class="mg-t-13px f-s-16px f-w-bold">
          <div class="checkout-btn cs-not-allowed mg-auto pd-8px" v-if="receivedCash < netPrice || fullPrice === 0"> ชำระเงินเสร็จสิ้น </div>
          <div class="checkout-btn cs-pointer mg-auto pd-8px" v-else  @click="finishCheckout('Cash')"> ชำระเงินเสร็จสิ้น </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="activeModal" :canCancel="[]">
      <SelectPrinter/>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectPrinter from './components/SelectPrinter'

export default {
  name: 'checkout-by-cash',
  components: {
    SelectPrinter
  },
  data () {
    return {
      receive: 0,
      activeModal: false
    }
  },
  methods: {
    ...mapActions([
      'setChange',
      'setReceivedCash',
      'calculatedChange',
      'checkout',
      'setIsloading',
      'fetchPrinters'
    ]),
    async finishCheckout (paymentType) {
      if (this.change < 0) {
        this.$dialog.alert({
          title: 'เกิดข้อผิดพลาด',
          confirmText: 'ตกลง',
          message: 'เงินที่ได้รับน้อยกว่ามูลค้าสินค้า <br> กรุณาใส่จำนวนเงินที่ได้รับใหม่อีกครั้ง'
        })
      } else {
        this.setIsloading(true)
        await this.checkout(paymentType)
        this.setIsloading(false)
        this.activeModal = true
      }
    },
    clear () {
      this.setChange(0)
      this.setReceivedCash(0)
      this.receive = 0
    },
    addReceive (money) {
      this.receive = (this.receive === '') ? money : parseInt(this.receive) + money
      this.calculatedChange({receive: this.receive, netPrice: this.netPrice})
    }
  },
  computed: {
    ...mapGetters({
      netPrice: 'getNetPrice',
      fullPrice: 'getFullPrice',
      change: 'getChange',
      receivedCash: 'getReceivedCash'
    })
  },
  async mounted () {
    await this.fetchPrinters()
  }
}
</script>

<style scoped>
.checkout-btn {
  width: 160px;
  height: 36px;
  border-radius: 4px;
  background-color: #000000;
  border: solid 1px #e5e5e5;
  color: #ffffff;
}
.price-btn {
  width: 53px;
  height: 36px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #000000;
}
.price-inp {
  width: 152px;
  height: 36px;
  /* border-radius: 4px; */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
}
.calculate-price-btn {
  width: 36px;
  height: 36px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #000000;
}
.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; 
}
</style>



// WEBPACK FOOTER //
// src/views/check-out/CheckoutByCash.vue